/* eslint-disable no-unused-vars */
import { memo } from 'react';
import { Buttons, Label, CustomInput, IconButton } from 'components';
import { DeleteIcon } from 'assets/icons';
import * as S from './CustomTokenEvent.styled';
import uuid from 'react-uuid';
import { useComputed } from '@preact/signals-react';

const convertField = (fieldName) => {
  if (fieldName.includes('tokenInput_')) return 'event_callback_';
  if (fieldName.includes('eventNameInput_')) return 'event_name';
};

const CustomTokenEvents_v1 = ({ events$, onChange, onBlur }) => {
  return (
    <>
      <div>
        <div>
          {useComputed(() =>
            events$.value.length > 0 ? (
              <div style={{ display: 'flex' }}>
                <Label text='Token' variant='description' style={{ flexGrow: '0.5' }} />
                <Label text='Event Name' variant='description' />
              </div>
            ) : null,
          )}

          <div>
            {useComputed(() =>
              events$.value.map((elem, index, arr) => {
                return (
                  <div
                    key={elem.token_id}
                    style={{ marginTop: '8px', display: 'flex', alignItems: 'center' }}
                  >
                    <CustomInput
                      onBlur={() => onBlur(elem)}
                      value={elem.event_callback_}
                      autoComplete='off'
                      id={`tokenInput_${uuid()}`}
                      name={`tokenInput_${uuid()}`}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        onChange({
                          type: 'change-token',
                          index,
                          value: newValue,
                        });
                      }}
                      placeholder='please insert token'
                      width={422}
                      inputStyle={S.LeftCustomInputStyle}
                    />
                    <CustomInput
                      onBlur={() => onBlur(elem)}
                      value={elem.event_name}
                      autoComplete='off'
                      id={`eventNameInput_${uuid()}`}
                      name={`eventNameInput_${uuid()}`}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        onChange({
                          type: 'change-name',
                          index,
                          value: newValue,
                        });
                      }}
                      placeholder='please insert event name'
                      width={422}
                      inputStyle={S.RightCustomInputStyle}
                    />
                    {elem.event_callback_.length || elem.event_name.length ? (
                      <IconButton.SmallSize
                        style={{
                          border: '1px solid #E2E8F0',
                          minWidth: '40px',
                          minHeight: '40px',
                          borderTopLeftRadius: 0,
                          borderBottomLeftRadius: 0,
                          zIndex: 1000,
                        }}
                        onClick={() => {
                          if (arr.length > 3) {
                            onChange({
                              type: 'delete',
                              index,
                            });
                          } else {
                            onChange({
                              type: 'change-token',
                              index,
                              value: '',
                            });
                            onChange({
                              type: 'change-name',
                              index,
                              value: '',
                            });
                          }
                        }}
                        icon={DeleteIcon}
                        type={IconButton.btnTypes.tertiary}
                        isDefaultMuted
                      />
                    ) : null}
                  </div>
                );
              }),
            )}
          </div>
        </div>
      </div>
      {useComputed(() =>
        events$.value.length > 0 ? (
          <div
            className='wrap'
            style={{
              width: 'fit-content',
              marginTop: '8px',
              marginBottom: '16px',
            }}
          >
            <Buttons.SecondaryNormal
              id='add_more_event'
              onClick={() => {
                onChange({
                  type: 'add',
                });
              }}
              //disabled={addBtnIsDisabled}
            >
              Add more event
            </Buttons.SecondaryNormal>
          </div>
        ) : null,
      )}
    </>
  );
};

export default memo(CustomTokenEvents_v1);
